import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { GetJobProgressionRequest, GetManyJobProgressionsRequest, SetDraftApprovedProgressionRequest, SetDraftRejectedProgressionRequest, SetReadyToFileProgressionRequest } from '@taxfyle/api-internal/internal/job_progression_pb';
import { RealtimeEvent } from '@taxfyle/api-internal/internal/realtime_pb';
import { Store } from 'libx';
import { tap } from 'rxjs/operators';
import env from '../misc/env';
import { JobProgressionAPI } from './API';
import { JobProgression } from './JobProgression';
var TypeCase = RealtimeEvent.TypeCase;
var JobProgressionStore = /*#__PURE__*/function (_Store) {
  function JobProgressionStore() {
    var _this;
    _classCallCheck(this, JobProgressionStore);
    _this = _callSuper(this, JobProgressionStore, arguments);
    _this.progressions = _this.collection({
      model: JobProgression,
      idAttribute: 'jobId'
    });
    _this.api = new JobProgressionAPI({
      baseURL: env.WORK_DOTNET_API,
      token$: _this.rootStore.authStore.token$
    }, _this.rootStore.workRealtime$);
    /**
     * Prompt events from the realtime channel.
     */
    _this.events$ = _this.api.events$.pipe(tap(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.handleProgressionRealtimeEvent(e));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()));
    _this.events$.subscribe();
    return _this;
  }

  /**
   * Gets the current step info for job
   */
  _inherits(JobProgressionStore, _Store);
  return _createClass(JobProgressionStore, [{
    key: "currentStepInfoForJob",
    value: function currentStepInfoForJob(jobId) {
      var progression = this.progressions.find(function (p) {
        return p.jobId === jobId;
      });
      return progression === null || progression === void 0 ? void 0 : progression.currentStepInfo;
    }

    /**
     * Gets the steps info for job
     */
  }, {
    key: "stepsInfoForJob",
    value: function stepsInfoForJob(jobId) {
      var progression = this.progressions.find(function (p) {
        return p.jobId === jobId;
      });
      return progression === null || progression === void 0 ? void 0 : progression.stepsInfo;
    }

    /**
     * Lists all progression steps.
     * @param jobId
     * @returns
     */
  }, {
    key: "fetchProgression",
    value: (function () {
      var _fetchProgression = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(jobId) {
        var request, response, progression;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              request = new GetJobProgressionRequest().setJobId(jobId);
              _context2.next = 3;
              return this.api.getProgression(request);
            case 3:
              response = _context2.sent;
              progression = response.toObject();
              return _context2.abrupt("return", this.progressions.set({
                id: progression.id,
                jobId: jobId,
                progressionSteps: progression.progressionStepsList,
                flow: progression.progressionFlow
              }));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchProgression(_x2) {
        return _fetchProgression.apply(this, arguments);
      }
      return fetchProgression;
    }()
    /**
     * Fetches all progressions for the job IDs provided.
     * @param {*} params
     * @returns
     */
    )
  }, {
    key: "fetchManyProgressions",
    value: (function () {
      var _fetchManyProgressions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        var response, progressions, dtos;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.api.getManyProgression(new GetManyJobProgressionsRequest().setJobIdsList(params.jobIds));
            case 2:
              response = _context3.sent;
              progressions = response.getProgressionsList().map(function (s) {
                return s.getProgression().toObject();
              });
              dtos = progressions.map(function (p) {
                return {
                  id: p.id,
                  jobId: p.jobId,
                  progressionSteps: p.stepsList,
                  flow: p.progressionFlow
                };
              });
              return _context3.abrupt("return", this.progressions.set(dtos));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchManyProgressions(_x3) {
        return _fetchManyProgressions.apply(this, arguments);
      }
      return fetchManyProgressions;
    }()
    /**
     * Primes a progression in the local collection.
     *
     * @param id
     */
    )
  }, {
    key: "primeProgression",
    value: function primeProgression(_ref2) {
      var jobId = _ref2.jobId;
      var existing = this.progressions.find(function (s) {
        return s.jobId === jobId;
      });
      if (existing) {
        return existing;
      }
      return this.progressions.set({
        jobId: jobId
      });
    }

    /**
     * Sets the current progression to draft rejected.
     * @param jobId
     */
  }, {
    key: "setDraftRejectedProgression",
    value: (function () {
      var _setDraftRejectedProgression = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(jobId) {
        var request;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              request = new SetDraftRejectedProgressionRequest().setJobId(jobId);
              _context4.next = 3;
              return this.api.setDraftRejectedProgression(request);
            case 3:
              _context4.next = 5;
              return this.fetchProgression(jobId);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function setDraftRejectedProgression(_x4) {
        return _setDraftRejectedProgression.apply(this, arguments);
      }
      return setDraftRejectedProgression;
    }()
    /**
     * Sets the current progression to draft approved.
     * @param jobId
     */
    )
  }, {
    key: "setDraftApprovedProgression",
    value: (function () {
      var _setDraftApprovedProgression = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(jobId) {
        var request;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              request = new SetDraftApprovedProgressionRequest().setJobId(jobId);
              _context5.next = 3;
              return this.api.setDraftApprovedProgression(request);
            case 3:
              _context5.next = 5;
              return this.fetchProgression(jobId);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function setDraftApprovedProgression(_x5) {
        return _setDraftApprovedProgression.apply(this, arguments);
      }
      return setDraftApprovedProgression;
    }()
    /**
     * Sets the current progression to ready to file.
     */
    )
  }, {
    key: "setReadyToFileProgression",
    value: (function () {
      var _setReadyToFileProgression = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(jobId) {
        var request;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              request = new SetReadyToFileProgressionRequest().setJobId(jobId);
              _context6.next = 3;
              return this.api.setReadyToFileProgression(request);
            case 3:
              _context6.next = 5;
              return this.fetchProgression(jobId);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function setReadyToFileProgression(_x6) {
        return _setReadyToFileProgression.apply(this, arguments);
      }
      return setReadyToFileProgression;
    }())
  }, {
    key: "handleProgressionRealtimeEvent",
    value: function () {
      var _handleProgressionRealtimeEvent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(event) {
        var _event$getJobProgress, proto;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.t0 = event.getTypeCase();
              _context7.next = _context7.t0 === TypeCase.JOB_PROGRESSION ? 3 : 6;
              break;
            case 3:
              proto = (_event$getJobProgress = event.getJobProgression()) === null || _event$getJobProgress === void 0 ? void 0 : _event$getJobProgress.toObject();
              _context7.next = 6;
              return this.fetchProgression(proto.jobId);
            case 6:
              return _context7.abrupt("return", null);
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function handleProgressionRealtimeEvent(_x7) {
        return _handleProgressionRealtimeEvent.apply(this, arguments);
      }
      return handleProgressionRealtimeEvent;
    }()
  }]);
}(Store);
export { JobProgressionStore as default };
//# sourceMappingURL=JobProgressionStore.js.map
